import { StateManager } from '../stateManager';
import {
  SET_NEW_UI,
  SET_INVALID_SEARCH,
  SET_SHOW_EMPTY_STATE,
  SET_ORDERS,
  SET_CUSTOMER_DETAILS,
  SET_LOADING,
  SET_SHOW_SHIMMER,
  SET_SEARCH_TYPE,
  SET_SEARCH_VALUE,
  SET_HAS_MORE_ORDERS,
  SET_WFH,
  SET_ANNOUNCEMENTS,
  SET_ALERTS,
  SET_ERROR,
  SHOW_BLOCKING_POPUP,
  SET_IS_TIMELINE_UPDATED,
  SET_NEW_USER_DATA,
  SET_SHOW_ARCHIVED_DETAILS,
  SET_NEXT_CURSOR,
  IS_REVAMP_ENABLED,
  IS_LIVE_ORDERS_VIEW_ENABLED,
} from './actions';

export const initialState = {
  isNewUI: false,
  isRevampEnabled: false,
  isLiveOrdersViewEnabled: false,
  showArchivedDetails: false,
  isSearchInvalid: false,
  isShowEmptyState: true,
  isLoading: true,
  orders: null,
  isShowShimmer: false,
  searchType: 'order_id',
  searchValue: '',
  hasMoreOrders: false,
  announcements: null,
  alerts: null,
  isWFH: 0,
  error: false,
  isBlockingPopup: false,
  isTimelineUpdated: {},
  newUserData: null,
  nextCursor: null,
};

const setNewUI = (state, action) => {
  let { value } = action;
  return { ...state, isNewUI: value };
};

const isRevampEnabled = (state, action) => {
  let { value } = action;
  return { ...state, isRevampEnabled: value };
};

const isLiveOrdersViewEnabled = (state, action) => {
  let { value } = action;
  return { ...state, isLiveOrdersViewEnabled: value };
};

const setShowArchivedDetails = (state, action) => {
  let { value } = action;
  return { ...state, showArchivedDetails: value };
};

const setInvalidSearch = (state, action) => {
  let { value } = action;
  return { ...state, isSearchInvalid: value };
};

const setShowEmptyState = (state, action) => {
  let { value } = action;
  return { ...state, isShowEmptyState: value };
};

const setOrders = (state, action) => {
  let { orders } = action;
  return { ...state, ...state.orders, orders: orders };
};

const setCxDetails = (state, action) => {
  let { cxDetails } = action;
  return {
    ...state,
    customer_id: cxDetails?.customer_id,
    customer_name: cxDetails?.customer_name,
  };
};

const setAnnouncements = (state, action) => {
  const announcements = action.payload;
  return { ...state, ...state.announcements, announcements: announcements };
};

const setAlerts = (state, action) => {
  const alerts = action.payload;
  return { ...state, ...state.alerts, alerts: alerts };
};

const setLoading = (state, action) => {
  let { isLoading } = action;
  return { ...state, isLoading: isLoading };
};

const setShowShimmer = (state, action) => {
  let { isShowShimmer } = action;
  return { ...state, isShowShimmer: isShowShimmer };
};

const setSearchType = (state, action) => {
  let { searchType } = action;
  return { ...state, searchType: searchType };
};

const setSearchValue = (state, action) => {
  let { value } = action;
  return { ...state, searchValue: value };
};

const setHasMoreOrders = (state, action) => {
  let { hasMore } = action;
  return { ...state, hasMoreOrders: hasMore };
};

const setNextCursor = (state, action) => {
  let { nextCursor } = action;
  return { ...state, nextCursor: nextCursor };
};

const setWFH = (state, action) => {
  let { value } = action;
  return { ...state, isWFH: value };
};

const setError = (state, action) => {
  let { value } = action;
  return { ...state, error: value };
};

const showBlockingPopup = (state, action) => {
  let { value } = action;
  return { ...state, isBlockingPopup: value };
};

const setIsTimelineUpdated = (state, action) => {
  let { value } = action;
  return { ...state, isTimelineUpdated: value };
};

const setNewUserData = (state, action) => {
  let { payload } = action;
  return { ...state, newUserData: payload };
};

const actions = {
  [SET_NEW_UI]: setNewUI,
  [SET_SHOW_ARCHIVED_DETAILS]: setShowArchivedDetails,
  [SET_INVALID_SEARCH]: setInvalidSearch,
  [SET_SHOW_EMPTY_STATE]: setShowEmptyState,
  [SET_ORDERS]: setOrders,
  [SET_CUSTOMER_DETAILS]: setCxDetails,
  [SET_LOADING]: setLoading,
  [SET_SHOW_SHIMMER]: setShowShimmer,
  [SET_SEARCH_TYPE]: setSearchType,
  [SET_SEARCH_VALUE]: setSearchValue,
  [SET_HAS_MORE_ORDERS]: setHasMoreOrders,
  [SET_NEXT_CURSOR]: setNextCursor,
  [SET_ANNOUNCEMENTS]: setAnnouncements,
  [SET_ALERTS]: setAlerts,
  [SET_WFH]: setWFH,
  [SET_ERROR]: setError,
  [SHOW_BLOCKING_POPUP]: showBlockingPopup,
  [SET_IS_TIMELINE_UPDATED]: setIsTimelineUpdated,
  [SET_NEW_USER_DATA]: setNewUserData,
  [IS_REVAMP_ENABLED]: isRevampEnabled,
  [IS_LIVE_ORDERS_VIEW_ENABLED]: isLiveOrdersViewEnabled,
};

const manager = new StateManager(initialState, actions);

export default manager.reducer;
